import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

export interface SelectionAction {
  label: string;
  onClick: () => void | Promise<void>;
  variant?: 'contained' | 'outlined';
  color?: 'primary' | 'error' | 'success';
  disabled?: boolean;
  loading?: boolean;
}

interface SelectionToolbarProps {
  count: number;
  actions: SelectionAction[];
  onClear: () => void;
}

export const SelectionToolbar: React.FC<SelectionToolbarProps> = ({ count, actions, onClear }) => {
  if (count === 0) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.08)',
        px: 3,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        zIndex: 1200,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.8125rem' }}>
        {count} selected
      </Typography>
      {actions.map(action => (
        <Button
          key={action.label}
          size="small"
          variant={action.variant ?? 'contained'}
          color={action.color ?? 'primary'}
          disabled={action.disabled || action.loading}
          onClick={action.onClick}
          startIcon={action.loading ? <CircularProgress size={14} /> : undefined}
          sx={{ textTransform: 'none', fontSize: '0.75rem', fontWeight: 600 }}
        >
          {action.label}
        </Button>
      ))}
      <Button
        size="small"
        variant="outlined"
        onClick={onClear}
        sx={{ textTransform: 'none', fontSize: '0.75rem', ml: 'auto' }}
      >
        Clear
      </Button>
    </Box>
  );
};
